import {React} from '@api'

import styled from '@react-pdf/styled-components'
import {useCatalog} from '@stores'


/* https://app.zeplin.io/project/5db1a9513b7725126d421cdb/screen/5db1a975e3284023b2fd5516 */

export const ProductPageStyledComponents = () => {

  const {pdfConfig: {defaultTemplate: {productPage: {fontFamily}}}} = useCatalog()

  const MyReportPage = styled.Page`
    padding: 20px 36px;
    display: flex;
    flex-direction: column;
    font-size: 8pt;
    font-family: Arial;
  `

  const Products = styled.View`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-content: flex-start;
    width: 100%;
  `

  const ProductRow = styled.View`
    display: flex;
    flex-grow: 0;
    flex-shrink: 1;
    flex-direction: row;
    justify-content: flex-start;
    overflow: hidden;
    flex-wrap: nowrap;
    margin-top: 0;
  `

  const CardContainer = styled.View`
    overflow: hidden;
    margin: 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  `

  const OneRowImageContainer = styled.View`
    display: flex;
    flex-grow: 0;
    flex-shrink: 1;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    flex-wrap: nowrap;
    margin-top: 0;
    flex-direction: row;
  `

  const Title = styled.View`
    display: flex;
    flex-direction: row;
    width: 100%;
    z-index: 1;
    margin-bottom: 10px;
  `

  const Footer = styled.View`
    position: absolute;
    left: 35px;
    bottom: 20px;
    font-size: 8pt;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  `

  const Left = styled.View`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    min-width: 200px;
  `

  const Right = styled.View`
    display: flex;
    flex-basis: 75%;
    flex-direction: row;
    margin-left: 10px;
    justify-content: flex-end;
  `

  const BrandLogo1 = styled.Image`
    flex-grow: 0;
    width: 100px;
  `

  const Breadcrumbs = styled.Text`
    display: flex;
    text-transform: capitalize;
  `

  const BrandNameText = styled.Text`
    font-family: Arial Bold;
    font-weight: bold;
    text-transform: uppercase;
  `

  const CurrentDateText = styled.Text`
    text-transform: uppercase;
    font-family: ${fontFamily.currentDate};
    margin-left: 8px;
  `

  const PageNumberText = styled.Text`
    display: flex;
    flex-direction: row;
    flex-basis: auto;
  `
  const FilterFooter = styled.View`
    display: flex;
    flex-direction: row;
    text-overflow: ellipsis;
    justify-content: flex-end;
    margin-right: 20px;
    max-height: 12px;
    flex-basis: 80%;
    font-family: ${fontFamily.filterFooter};
  `

  const FiltersText = styled.Text`
    display: flex;
    font-weight: normal !important;
    font-family: ${fontFamily.filterText};
    white-space: nowrap;
  `
  const AttributeText = styled.Text`
    display: flex;
    font-family: ${fontFamily.attributeText};
    text-transform: uppercase;
    font-weight: bold;
    white-space: nowrap;
  `

  const HeaderView = styled.View`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    height: 8mm;
    
  `
  const BrandView = styled.View`
    display: flex;
  `

  const BrandLogo = styled.Image`
    object-fit: fill;
    width: 100%;
    max-width: 150px;
    padding-left: 2mm;
  `
  const HierarchyView = styled.View`
    display: flex;
    margin-top: 1.3mm;
    flex-direction: row;
    justify-content: flex-end;
    width: 70%
  `
  const OnlyHierarchyView = styled(HierarchyView)`
    width: 100%;
    justify-content: flex-end;
  `
  const HeaderHierarchy = styled.Text`
    font-size: 9pt;
    justify-content: right;
    font-family: ${fontFamily.headerHierarchy};
    word-break: break-word;
  `

  return {
    MyReportPage,
    Products,
    ProductRow,
    CardContainer,
    OneRowImageContainer,
    Title,
    Footer,
    Left,
    Right,
    BrandLogo1,
    Breadcrumbs,
    BrandNameText,
    CurrentDateText,
    PageNumberText,
    FilterFooter,
    FiltersText,
    AttributeText,
    HeaderView,
    BrandView,
    BrandLogo,
    HierarchyView,
    OnlyHierarchyView,
    HeaderHierarchy
  }

}



// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpProductPage.styles.tsx